module.exports = __webpack_public_path__ + "static/media/slide5.9ea2b42a.jpg";